import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

const BreedingHistoryPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [horse, setHorse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get(`/horses/${id}`).then(r => setHorse(r.data)).catch(() => toast.error('Failed')).finally(() => setLoading(false));
  }, [id]);

  const set = (f) => (e) => { const v = e.target.value; setHorse(p => ({ ...p, [f]: v })); };

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/horses/${id}`, {
        repro_status: horse.repro_status,
        repro_total_foals: horse.repro_total_foals,
        repro_losses: horse.repro_losses,
        repro_history_notes: horse.repro_history_notes,
      });
      toast.success('Saved');
      navigate(`/horses/${id}/breeding`);
    } catch (e) { toast.error('Failed'); } finally { setSaving(false); }
  };

  if (loading || !horse) return <div className="loading-screen"><div className="spinner" /></div>;

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-secondary)', paddingBottom: 40 }}>
      <div className="top-bar">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button onClick={() => navigate(`/horses/${id}/breeding`)} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', fontSize: 20, padding: '4px 8px 4px 0' }}>‹</button>
          <h1 style={{ color: 'white', fontSize: 17, flex: 1 }}>Reproductive history</h1>
        </div>
      </div>
      <div style={{ padding: 12 }}>
        <div className="card">
          <p style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 12 }}>This history stays with {horse.name} across every breeding season.</p>
          <div className="form-group">
            <label className="form-label">Status</label>
            <select className="form-input" value={horse.repro_status || 'unknown'} onChange={set('repro_status')}>
              <option value="unknown">Unknown</option>
              <option value="maiden">Maiden (never bred)</option>
              <option value="proven">Proven (has foaled)</option>
              <option value="barren">Barren</option>
            </select>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <div className="form-group">
              <label className="form-label">Total foals</label>
              <input className="form-input" type="number" value={horse.repro_total_foals || 0} onChange={set('repro_total_foals')} />
            </div>
            <div className="form-group">
              <label className="form-label">Losses</label>
              <input className="form-input" type="number" value={horse.repro_losses || 0} onChange={set('repro_losses')} />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">History notes</label>
            <textarea className="form-input" rows={5} value={horse.repro_history_notes || ''} onChange={set('repro_history_notes')}
              placeholder="Prior foalings, any complications (dystocia, red bag, foal presenting backwards), losses, notes that matter each season." />
          </div>
          <button className="btn btn-primary btn-full" onClick={save} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
        </div>
      </div>
    </div>
  );
};

export default BreedingHistoryPage;
